import React from "react";
import ContactSection from "../Components/contact-us/ContactSection";
import "../contact-store.css";

export default function Contact() {
  return <ContactSection />;
}
